/* eslint-disable max-len */
/**
 * 待缴费清单相关 文案配置
 */

export default {
  autopay: {
    deductionPlanServiceNotice: 'If you want to cancel the automatic debit service, please contact our customer service: Malaysia@tal.com',
    contactNumber: '【Malaysia@tal.com】',
  },
}
